import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Ambient Fingerprinting made our corporate background check process incredibly smooth. They came right to our office and handled 20 employees in record time.',
    author: 'Sarah Jenkins',
    role: 'HR Director, Tech Solutions Inc.'
  }, {
    quote: 'Professional, punctual, and very efficient. The Live Scan process was quick, and I received my results faster than expected. Highly recommend!',
    author: 'Michael Chen',
    role: 'Healthcare Professional'
  }];
  return <section className="py-12 lg:py-20 bg-slate-50 border-b border-slate-200/60 relative overflow-hidden" aria-labelledby="testimonials-heading" data-id="element-231">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-40 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#4AA6CF 0.5px, transparent 0.5px)',
      backgroundSize: '32px 32px'
    }} data-id="element-232" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-233">
        <div className="text-center mb-16 lg:mb-20" data-id="element-234">
          <h2 id="testimonials-heading" className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6 tracking-tight" data-id="element-235">
            What Our Clients Say
          </h2>
          <div className="w-16 h-1.5 bg-[#4AA6CF] mx-auto rounded-full mb-8" aria-hidden="true" data-id="element-236"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-237">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-white p-8 lg:p-12 rounded-2xl border border-slate-200 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500 relative" data-id="element-238">
              <QuoteIcon className="absolute top-8 right-8 h-12 w-12 text-slate-50" aria-hidden="true" data-id="element-239" />
              <p className="text-slate-600 text-lg italic mb-10 leading-relaxed relative z-10" data-id="element-240">
                "{t.quote}"
              </p>
              <div className="relative z-10" data-id="element-241">
                <p className="font-extrabold text-slate-900 text-lg mb-1" data-id="element-242">
                  {t.author}
                </p>
                <p className="text-[#4AA6CF] font-bold text-sm" data-id="element-243">{t.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}